import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useGetBookmarksQuery } from '@backrs_ui/grow-ui/src/redux/bookmarks/bookmarks.api';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { BookmarkPage } from './BookmarkPage';

export const BookmarkPageContainer = () => {
  const { data: bookmarks, isLoading: bookmarksLoading } = useGetBookmarksQuery(undefined);
  const { loading: nuggetsLoading } = useAppSelector((state) => state.contentNugget);

  if (nuggetsLoading || bookmarksLoading) {
    return <FullScreenLoading />;
  }

  return <BookmarkPage bookmarks={bookmarks} />;
};
